import { Link } from "react-router-dom";
import { PlayCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageHeader, Section } from "@/components/kit";
import { GuideSteps } from "@/components/GuideButton";
import { GUIDES } from "@/lib/guides";
import { useAuth } from "@/context/AuthContext";

export default function Guia() {
  const { user } = useAuth();
  const entries = Object.entries(GUIDES).filter(([p]) => p !== "/app/admin" || user?.role === "admin");
  return (
    <div data-testid="guia-page">
      <PageHeader eyebrow="Ajuda" title="Guia de uso" subtitle="Passo a passo de cada aba do PROSPERA+. Comece pela Visão geral, registre seus lançamentos e cartões e depois use planejamento, metas e mentor.">
        <Button variant="outline" className="border-[#D4AF37]/50 bg-transparent text-[#F5D77F]" onClick={() => window.dispatchEvent(new Event("prospera:tour"))} data-testid="restart-tour-btn">
          <PlayCircle className="mr-1 h-4 w-4" /> Rever tour inicial
        </Button>
      </PageHeader>
      <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
        {entries.map(([path, g], i) => (
          <Section key={path} title={`${i + 1}. ${g.title}`} testid={`guide-section-${path.split("/").pop() || "visao"}`}>
            <GuideSteps guide={g} />
            <Link to={path} className="mt-4 inline-block text-sm text-[#F5D77F] hover:underline" data-testid={`guide-open-${path.split("/").pop() || "visao"}`}>Abrir {g.title} →</Link>
          </Section>
        ))}
      </div>
    </div>
  );
}
